module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [_c('div', {
    staticClass: "part-1"
  }, [_c('div', {
    staticClass: "nav"
  }, _vm._l((_vm.navItem), function(item, index) {
    var _obj;

    return _c('div', {
      key: index,
      class: ['icon', 'icon-' + item, ( _obj = {}, _obj['icon-active-' + item] = _vm.activeItem == index, _obj )],
      on: {
        "click": function($event) {
          return _vm.switchNav(index)
        }
      }
    })
  }), 0), _vm._v(" "), (_vm.activeItem === 0) ? _c('div', {
    staticClass: "content content1"
  }, [(_vm.banner.length != 0) ? _c('swiper', {
    ref: "mySwiper",
    staticClass: "swiper-wrap",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.banner), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "swiper-div"
    }, [_c('p', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('img', {
      staticClass: "img-item",
      attrs: {
        "src": item.src,
        "alt": ""
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "monitor"
    }, [_vm._v("视频监控 " + _vm._s(index + 1) + "/" + _vm._s(_vm.banner.length))])])])
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activeItem === 1) ? _c('div', {
    staticClass: "content content2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "see-details",
    on: {
      "click": _vm.showDetails
    }
  }, [_vm._v("查看详情")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "modal-details"
  }, [_c('i', {
    staticClass: "close",
    on: {
      "click": _vm.hideDetails
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "static/img/base/weather-station.png",
      "alt": ""
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.activeItem === 2) ? _c('div', {
    staticClass: "content content3"
  }, _vm._l((_vm.content3Data), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.value))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.activeItem === 3) ? _c('div', {
    staticClass: "content content4"
  }, _vm._l((_vm.content4Data), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.value))])])
  }), 0) : _vm._e()]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n        气象站\n        "), _c('span', [_vm._v("运行中")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "part-2"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("显示内容")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("摄像头（1个）")]), _vm._v(" "), _c('div', [_vm._v("传感设备（1个）")])]), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("气象站（1个）")]), _vm._v(" "), _c('div', [_vm._v("灌溉设备（1个）")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "part-3"
  }, [_c('p', [_vm._v("地址：广西省百色市")]), _vm._v(" "), _c('p', [_vm._v("占地面积：20000余亩")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9f1e7220!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/details/index.vue
// module id = 2066
// module chunks = 2